/**
 * ============================================================
 * ELOISE ACCESSOIRES — filters.js
 * Filtres AJAX — chargé uniquement sur template collection
 *
 * Fonctionnalités (phase 2) :
 *   - Filtres par facettes (prix, matière, taille, collection)
 *   - Rechargement AJAX de la grille produits sans reload complet
 *   - Mise à jour URL (history.pushState) pour partage et back button
 *   - Tri dynamique (prix, nouveauté, popularité)
 *   - Compteur de résultats en temps réel
 *   - Réinitialisation des filtres
 *
 * Endpoint Shopify :
 *   GET /collections/[handle]?filter.p.tag=...&sort_by=...
 *   (section rendering API : ?section_id=collection-grid)
 *
 * Actuellement : stub — chargement sans erreur garanti
 * ============================================================
 */

'use strict';

document.addEventListener('DOMContentLoaded', () => {
  // Filtres collection — à implémenter en phase 2
  // initCollectionFilters();
});

// export function initCollectionFilters() { ... }
